import { MakeLogicType, actions, defaults, kea, path, reducers } from 'kea'

export type ErrorTrackingIssueSceneCategory = 'exceptions' | 'breakdowns'

export const VALID_CATEGORIES: ErrorTrackingIssueSceneCategory[] = ['exceptions', 'breakdowns']
export const DEFAULT_CATEGORY: ErrorTrackingIssueSceneCategory = 'exceptions'

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface errorTrackingIssueSceneConfigurationLogicValues {
    category: ErrorTrackingIssueSceneCategory
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface errorTrackingIssueSceneConfigurationLogicActions {
    setCategory: (category: ErrorTrackingIssueSceneCategory) => {
        category: ErrorTrackingIssueSceneCategory
    }
}

export type errorTrackingIssueSceneConfigurationLogicType = MakeLogicType<
    errorTrackingIssueSceneConfigurationLogicValues,
    errorTrackingIssueSceneConfigurationLogicActions
>

export const errorTrackingIssueSceneConfigurationLogic = kea<errorTrackingIssueSceneConfigurationLogicType>([
    path([
        'products',
        'error_tracking',
        'scenes',
        'ErrorTrackingIssueScene',
        'errorTrackingIssueSceneConfigurationLogic',
    ]),

    actions({
        setCategory: (category: ErrorTrackingIssueSceneCategory) => ({ category }),
    }),

    defaults({
        category: DEFAULT_CATEGORY as ErrorTrackingIssueSceneCategory,
    }),

    reducers(() => ({
        category: {
            setCategory: (_, { category }) => category,
        },
    })),
])
